(ns ui.view.survey.modals.missing-sheets
  (:require
   [common.localization :as loc]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]
   [ui.view.survey.event :as survey-view-event]
   [ui.view.survey.modals.sub :as sub]
   [ui.view.survey.sub :as survey-view-sub]))

(defn missing-required-sheets-message
  []
  [:div
   {:class-name "p-4 flex flex-col gap-2"}
   [:p
    {:class-name "pb-4"}
    (loc/tr :survey-import-missing-sheets)]])

(defn missing-required-sheets-footer
  [{:keys [hide!]}]
  [:div
   {:class "flex flex-row flex-auto"}
   [:div
    {:class "flex flex-row flex-auto content-stretch justify-content-end"}
    [button/secondary-hollow
     {:on-click hide!}
     (loc/tr :close)]]])

(defn view
  []
  (let [survey-id @(rf/subscribe [::sub/survey-id])
        show? @(rf/subscribe [::survey-view-sub/missing-required-sheets? survey-id])
        hide! #(rf/dispatch [::survey-view-event/clear-errors-tesi survey-id])]
    [modal/view
     {:visible? show?
      :hide!    hide!
      :size     :full}
     (loc/tr :survey-import-failed)
     [missing-required-sheets-message]
     [missing-required-sheets-footer
      {:survey-id survey-id
       :hide! hide!}]]))
